import { ArrowUpRight } from 'lucide-react';
import { cn } from '@/lib/utils';
import { DRILL_DOWN_CHIP_CLASS, DRILL_DOWN_CHIP_ICON_CLASS } from '@/styles/drillDownChip';
import { GoogleMapsIcon } from './GoogleMapsIcon';

type GoogleMapsLinkSize = 'default' | 'compact';

const GOOGLE_MAPS_LINK_CLASS = cn(DRILL_DOWN_CHIP_CLASS, 'shrink-0 gap-1 text-xs');

const SIZE_CLASS = {
  default: 'max-lg:h-8 max-lg:gap-1.5 max-lg:px-2.5',
  compact: '',
} as const satisfies Record<GoogleMapsLinkSize, string>;

interface GoogleMapsLinkProps {
  href: string;
  label: string;
  title: string;
  size?: GoogleMapsLinkSize | undefined;
  className?: string | undefined;
}

export function GoogleMapsLink({
  href,
  label,
  title,
  size = 'default',
  className,
}: GoogleMapsLinkProps) {
  return (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      title={title}
      className={cn(GOOGLE_MAPS_LINK_CLASS, SIZE_CLASS[size], className)}
    >
      <GoogleMapsIcon className="size-3.5 shrink-0" />
      {label}
      <ArrowUpRight className={DRILL_DOWN_CHIP_ICON_CLASS} aria-hidden />
    </a>
  );
}
